import { request } from '@/utils/request'

//查询文件
export function searchFileListApi(data, that) {
    return request({
        url: '/srm/commonFile/query',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//查询文件目录列表
export function getFileListApi(subPath, that) {
    return request({
        url: '/srm/commonFile/dir',
        data: {},
        params: { subPath: subPath },
        that,
        method: 'get',
    })
}
//创建目录
export function newFolderApi(dirList, that) {
    return request({
        url: '/srm/commonFile/createDir',
        data: dirList,
        params: {},
        that,
        method: 'post',
    })
}
//删除文件
export function delFileApi(filePath, that) {
    return request({
        url: '/srm/commonFile/remove',
        data: {},
        params: { filePath: filePath },
        that,
        method: 'post',
    })
}

/**
 * @param {*} filePath 文件路径
 * @returns 
 * @description 下载文件
 */
export function viewFileApi(filePath, that) {
    return request({
        url: '/srm/commonFile/download',
        params: { filePath: filePath },
        that,
        method: 'get',
        load: true,
        responseType: 'blob',
        isFileRequest: true
    })
}


//批量上传文件
export function uploadFileApi(uploadData, that) {
    return request({
        url: '/srm/commonFile/uploadBatch',
        data: uploadData,
        that,
        method: 'post',
        isFileRequest: true,
        showSuccessNotification: false,
        onUploadProgress: progressEvent => {
            if (progressEvent.total) {
                that.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
        }
    }).then(res => {
        if (res.code == 100) {
            return Promise.resolve()
        } else {
            that.$notify.error({
                title: '上传失败',
                message: res.msg,
                duration: 0,
                position: 'bottom-right',
            });
            return Promise.reject({ isBusinessError: true })
        }
    }).catch(error => {
        if (error && error.isBusinessError) {
            return Promise.reject(error);
        }
        that.$notify.error({
            title: '上传失败',
            message: '服务器接口处理异常',
            duration: 0,
            position: 'bottom-right',
        });
        return Promise.reject(error)
    })
}

